import precise from '../modules/precise';
import VSVC from './data/vesselSVCConstants';

function getVesselFee(options) {
  const { shouldChargeVesselCountyFees, selectedVehicleDescription } = options;
  const BaseFee = Number(options.BaseFee);
  const BFfee = Number(options.BFfee);
  const cmm = Number(options.cmm);
  const r17 = Number(options.pipe.r17);
  const r16 = Number(options.pipe.r16);
  const r21 = Number(options.pipe.r21);
  const r12 = Number(options.pipe.r12);

  let vscf = 0;
  let total = 0;

  // Just add up all the Vessel SVC Fees
  const vesselFees = Object.keys(VSVC).reduce((acc, n) => VSVC[n] + acc, 0);

  if (vesselFees !== 4.75) {
    throw new Error('VSSvc should be 4.75 per 9/01/14 fees');
  }

  if (shouldChargeVesselCountyFees) {
    vscf = (BaseFee * 0.50);
    // Note the variables below vscf1 and vscf12 are assigned values, but never
    // used anywhere. They look important. Can we remove them, or should it be used somehow?
    // const vscf1 = ((Math.round(Number(r12) * 0.50 * 100)) / 12); // verified formula
    // const vscf12 = ((vscf1 * 12) / 100); // added 6/26 to set 12 month value of variable vessel county fee vscf

    // // Note that this this throws the calculations off.
    // // It should be removed, but is here temporarily for
    // // demonstration, evaluation and comparison.
    // if (vscf >= 1.75 || vscf < 1.75) {
    //   vscf = 1.75;
    // }
  }

  // If not 1 - 11 Ft or Exempt
  if (r17 !== 0) {
    total = BaseFee + vesselFees + BFfee + vscf + cmm;
  }

  if (r16 === 5 && ((r17 === 0) || (r17 === 2))) {
    // for exempt & antique vessels including commercial // 5.75
    total = 3.75 + BFfee + cmm;
  }

  return precise(total);
}

export default getVesselFee;



// WEBPACK FOOTER //
// ./src/modules/getVesselFee.js